import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.804 14.641a5.02 5.02 0 0 1 -.804 -.641a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8","key":"svg-0"}],["path",{"d":"M5 21v-7","key":"svg-1"}],["path",{"d":"M16 21l5 -5","key":"svg-2"}],["path",{"d":"M21 21v.01","key":"svg-3"}],["path",{"d":"M16 16v.01","key":"svg-4"}]]

const IconFlagDiscount = createReactComponent('outline', 'flag-discount', 'FlagDiscount', __iconNode);

export default IconFlagDiscount;